import React,{useContext, useEffect, useState} from 'react'
import { Context } from '../context/Context'
import { commonText as text } from '../Database/Database';
import { reactLocalStorage } from 'reactjs-localstorage';
import { getHeaders,body,base,redirect_url } from "../Config";
import axios from 'axios';
import { SendGuiDataEvents } from '../lib/CommonScript';


export default function LangModal() {

    const {lang,handleModal,modalData,handleVerifyUser,handleNewUser, handleShowLoader} = useContext(Context);
    const uid = reactLocalStorage.get("uid");

  // this checkSub is called when we click on modal which gets displayed in case of failed or successful unsub Request
  // when modal is displayed and when we click on ok button checkSub Request is made

    const checkSub = (uid) => {
      handleShowLoader(true)
      axios({
          method: 'post',
          url: base + "checkSub",
          data: JSON.stringify({'uid': uid}),
          headers: getHeaders()
          }
      ).then((resp) => {
        handleShowLoader(false)
          if(resp.data.status !== '' && resp.data.status != undefined){
                  if(resp.data.status === 'failed'){
                      // window.open(rediret_url,"_self")
                      const modalData = {
                          title : text.modal.oops[lang],
                          body : `${resp.data.message}`,
                          btn : [text.modal.okay[lang]]
                        }
                      handleModal(modalData , true)
                      handleVerifyUser(false)

                  }else if(resp.data.status === 'success'){
                      if(resp.data.subStatus === 'new'){
                          handleNewUser(true)
                      }
                  }
          }

              reactLocalStorage.set("subStatus",resp.data.subStatus)
              // set loader false
      }).then((error) => {
          console.log("error -----> ", error)
      })
  }


  const onHandleUnsub=(uid)=>{
    // unsub logic goes here
    handleShowLoader(true)
    axios({
        method: 'post',
        url: base + "unsubscribe",
        data:{"uid":uid},
        headers: {...getHeaders(), Language: `${lang}`}
        }
    ).then((resp) => {
        let guiDataEvents = {}
        guiDataEvents["event"] = "unsub"
        guiDataEvents["currentstatus"] = resp.data.currentstatus
        SendGuiDataEvents(guiDataEvents)
        console.log("unsub response ----> ",resp.data)
        if(resp.data.status !== '' && resp.data.status != undefined){
                if(resp.data.status === 'failed'){

                    const modalData = {
                      title : text.modal.oops[lang],
                      body : `${resp.data.message}`,
                      btn : [text.modal.okay[lang]]
                  }
                  handleModal(modalData , true)

                }else if(resp.data.status === 'success'){
                  // checkSub(uid)
                  const modalData = {
                    title : text.modal.oops[lang],
                    body : `${resp.data.message}`,
                    btn : [text.modal.okay[lang]],
                    apiName: "unsub"
                }
                handleModal(modalData , true)
                handleShowLoader(false)
                }
        }
            reactLocalStorage.set("subStatus",resp.data.subStatus)
            // set loader false
    }).then((error) => {
        console.log("error -----> ", error)
    })
}



  const closeModal = (value) => {
    if (modalData.btn.length > 1 && value === '1') {
      onHandleUnsub(uid)
    } else if (modalData.btn.length > 1 && value === '2') {
      console.log("No btn clicked")
    } else {
      console.log("Okay btn clicked")
      console.log("modalData ------->",modalData)
      if(modalData.apiName === 'unsub'){
        checkSub(uid)
      }else if(modalData.apiName === 'checksub'){
        console.log("checksub failed modal")
        window.open(redirect_url,"_self")
      }

    }
    handleModal(modalData,false);
  }


  return (
    <div className='absolute w-full max-w-[500px] h-full bg-green_bg_pic z-60'>
        <div className='w-[20rem] absolute bg-white top-36 left-0 right-0 mx-auto border-2 '>
        {/* <div className='text-right text-4xl pr-2' onClick={closeModal}>&times;</div> */}
        <div className='font-bold pt-6 text-xl'>{modalData.title}</div>
        <div className='pb-10 pt-3 px-10'>
            <p>{modalData.body}</p>
            <p className='mt-4 py-2 rounded font-bold text-white bg-darkGreen border'  onClick={() =>closeModal("1")}>{modalData.btn[0]}</p>
            {modalData.btn.length > 1 && <p className='font-bold mt-2 py-2 rounded  text-white  bg-bgGreenIslam border'  onClick={() =>closeModal("2")}>{modalData.btn[1]}</p>}
        </div>
    </div>
    </div>

  )
}
